export enum ChartParentType {
  COLUMN = 'COLUMN',
  LINE = 'LINE',
  STACKED_COLUMN = 'STACKED_COLUMN'
}
